import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's122g-s122m01',
    templateUrl: './s122g-s122m01.component.html'
})
export class S122gS122m01Component extends Overlay {
    scrndat: any = {};
    scrntim: any = {};
    scrnnm: any = {};
    sel1: any = {'value': '_'};
    fld1: any = {};
    sel2: any = {'value': '_'};
    fld2: any = {};
    sel3: any = {'value': '_'};
    fld3: any = {};
    sel4: any = {'value': '_'};
    fld4: any = {};
    sel5: any = {'value': '_'};
    fld5: any = {};
    sel6: any = {'value': '_'};
    fld6: any = {};
    sel7: any = {'value': '_'};
    fld7: any = {};
    sel8: any = {'value': '_'};
    fld8: any = {};
    sel9: any = {'value': '_'};
    fld9: any = {};
    sel10: any = {'value': '_'};
    fld10: any = {};
    sel11: any = {'value': '_'};
    fld11: any = {};
    sel12: any = {'value': '_'};
    fld12: any = {};
    sel13: any = {'value': '_'};
    fld13: any = {};
    sel14: any = {'value': '_'};
    fld14: any = {};
    sel15: any = {'value': '_'};
    fld15: any = {};
    msgln: any = {};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};

    public FIELDS: string[] = ['scrndat', 'scrntim', 'scrnnm', 'sel1', 'fld1', 'sel2', 'fld2', 'sel3', 'fld3', 'sel4', 'fld4', 'sel5', 'fld5', 'sel6', 'fld6', 'sel7', 'fld7', 'sel8', 'fld8', 'sel9', 'fld9', 'sel10', 'fld10', 'sel11', 'fld11', 'sel12', 'fld12', 'sel13', 'fld13', 'sel14', 'fld14', 'sel15', 'fld15', 'msgln', 'prevc1'];
    public LINES: number[] = [1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
